import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Text, Title } from '@siftscience/focus-components/text'
import { titleizeText } from '../utils'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    height: '136px',
    width: '312px',
    backgroundColor: 'rgba(247, 247, 247, 1)'
  }
}))

interface IProps {
  item: Record<string, string>
}

const formatAmount = (amount: number, currencyCode: string): string => {
  if (typeof amount !== 'number' || !currencyCode) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode
  }).format(amount)
}

const formatLifecycleStatus = (status: string): string => {
  if (status === 'document_sent') return 'Document Sent'
  if (status === 'updated') return 'Updated'
  return titleizeText(status)
}

const LinkedCard = ({ item }: IProps): React.ReactElement => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <Title size="small">{titleizeText(item.stage as string)}</Title>
      <div>
        <Title size="xsmall">Status</Title>
        <Text size="xsmall">
          {formatLifecycleStatus(item.lifecycle_status)}
        </Text>
      </div>
      <Text size="xsmall">{item.case_number}</Text>
      <Text size="large">
        {formatAmount(Number(item.dispute_amount), item.currency_code)}
      </Text>
    </div>
  )
}

export default LinkedCard
